(function vendorCookies() {
    !function(e){var n;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var t=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=t,o}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function n(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function t(o){function r(){}function i(n,t,i){if("undefined"!=typeof document){"number"==typeof(i=e({path:"/"},r.defaults,i)).expires&&(i.expires=new Date(1*new Date+864e5*i.expires)),i.expires=i.expires?i.expires.toUTCString():"";try{var c=JSON.stringify(t);/^[\{\[]/.test(c)&&(t=c)}catch(e){}t=o.write?o.write(t,n):encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var f="";for(var u in i)i[u]&&(f+="; "+u,!0!==i[u]&&(f+="="+i[u].split(";")[0]));return document.cookie=n+"="+t+f}}function c(e,t){if("undefined"!=typeof document){for(var r={},i=document.cookie?document.cookie.split("; "):[],c=0;c<i.length;c++){var f=i[c].split("="),u=f.slice(1).join("=");t||'"'!==u.charAt(0)||(u=u.slice(1,-1));try{var a=n(f[0]);if(u=(o.read||o)(u,a)||n(u),t)try{u=JSON.parse(u)}catch(e){}if(r[a]=u,e===a)break}catch(e){}}return e?r[e]:r}}return r.set=i,r.get=function(e){return c(e,!1)},r.getJSON=function(e){return c(e,!0)},r.remove=function(n,t){i(n,"",e(t,{expires:-1}))},r.defaults={},r.withConverter=t,r}(function(){})});
})();
window.theme = window.theme || {};
theme.Helpers = (function() {
    var touchDevice = false;
    function setTouch() {
        touchDevice = true;
    }

    function isTouch() {
        return touchDevice;
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this,
                args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function animateCSS(element, animation, prefix = 'animate__') {
        return new Promise(function(resolve, reject) {

            const animationName = `${prefix}${animation}`;
            // const node = document.querySelector(element);
            const node = element;

            node.classList.add(`${prefix}animated`, animationName);

            // When the animation ends, we clean the classes and resolve the Promise
            function handleAnimationEnd() {
                node.classList.remove(`${prefix}animated`, animationName);
                resolve('Animation ended');
            }

            node.addEventListener('animationend', handleAnimationEnd, {once: true});
        });
    }

    function Toggle(id) {
        var element = document.getElementById(id);
        if ( element.classList.contains('animate-hide') ) {
            element.classList.remove("animate-hide", "fadeOut");
            element.classList.add("animate-show", "fadeIn");
            element.style.visibility = "visible";
        } else {
            element.classList.remove("animate-show", "fadeIn");
            element.classList.add("animate-hide", "fadeOut");
            element.style.visibility = "hidden";
        }
    }

    function toggleClass(id, className) {
        var element = document.getElementById(id);
        if (!element) return false;
        if ( element.classList.contains(className) ) {
            element.classList.remove(className);
        } else {
            element.classList.add(className);
        }
    }

    function Accordion(container, tlink, submenu) {

        let accorContent = container.querySelector(submenu);

        if ( !container.querySelector(tlink) ) return false;

        container.querySelector(tlink).addEventListener('click', function(event) {
            event.preventDefault();

            // Toggle class on label and update a11y
            if ( this.classList.contains('closed') ) {
                this.classList.remove('closed');
                this.parentElement.classList.remove('closed');
                this.setAttribute('aria-expanded', 'true');
            } else {
                this.classList.add('closed');
                this.parentElement.classList.add('closed');
                this.setAttribute('aria-expanded', 'false');
            }

            // Show content
            if ( accorContent.classList.contains('closed') ) {
                accorContent.classList.remove("closed");
                accorContent.style.display = "block";
            } else {
                accorContent.classList.add("closed");
                accorContent.style.display = "none";
            }

        });
    }

    function fadeOut(el){
        el.style.opacity = 1;

        (function fade() {
            if ((el.style.opacity -= .1) < 0) {
                el.style.display = "none";
            } else {
                requestAnimationFrame(fade);
            }
        })();
    }

    function fadeIn(el, display){
        el.style.opacity = 0;
        el.style.display = display || "block";

        (function fade() {
            var val = parseFloat(el.style.opacity);
            if (!((val += .1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        })();
    }

    function getScrollbarWidth() {

        // Creating invisible container
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);

        // Creating inner element and placing it in the container
        const inner = document.createElement('div');
        outer.appendChild(inner);

        // Calculating difference between container's full width and the child width
        const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;

    }

    function smoothScrollTo(endX, endY, duration) {
        let startX = window.scrollX || window.pageXOffset,
            startY = window.scrollY || window.pageYOffset,
            distanceX = endX - startX,
            distanceY = endY - startY,
            startTime = new Date().getTime();
        // Easing function
        let easeInOutQuart = function(time, from, distance, duration) {
            if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
            return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
        };
        let timer = window.setInterval(function() {
            let time = new Date().getTime() - startTime,
                newX = easeInOutQuart(time, startX, distanceX, duration),
                newY = easeInOutQuart(time, startY, distanceY, duration);
            if (time >= duration) {
                window.clearInterval(timer);
            }
            window.scrollTo(newX, newY);
        }, 1000 / 60); // 60 fps
    }

    function formatMoney(cents, format) {
        const moneyFormat = '${{amount}}';

        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;

        function formatWithDelimiters(
            number,
            precision = 2,
            thousands = ',',
            decimal = '.'
        ) {
            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            const parts = number.split('.');
            const dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                `$1${thousands}`
            );
            const centsAmount = parts[1] ? decimal + parts[1] : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        setTouch: setTouch,
        isTouch: isTouch,
        debounce: debounce,
        animateCSS: animateCSS,
        Toggle: Toggle,
        toggleClass: toggleClass,
        Accordion: Accordion,
        fadeOut: fadeOut,
        fadeIn: fadeIn,
        getScrollbarWidth: getScrollbarWidth,
        smoothScrollTo: smoothScrollTo,
        formatMoney: formatMoney
    };
})();

theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
        'shopify:section:load',
        this._onSectionLoad.bind(this)
    );
    document.addEventListener(
        'shopify:section:unload',
        this._onSectionUnload.bind(this)
    );
    document.addEventListener(
        'shopify:section:select',
        this._onSelect.bind(this)
    );
    document.addEventListener(
        'shopify:section:deselect',
        this._onDeselect.bind(this)
    );
    document.addEventListener(
        'shopify:block:select',
        this._onBlockSelect.bind(this)
    );
    document.addEventListener(
        'shopify:block:deselect',
        this._onBlockDeselect.bind(this)
    );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var id = container.getAttribute('data-section-id');
        var type = container.getAttribute('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = Object.assign(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function(evt) {
        var container = document.querySelector(
            '[data-section-id="' + evt.detail.sectionId + '"]'
        );

        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function(evt) {
        this.instances = this.instances.filter(function(instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;

            if (isEventInstance) {
                if (typeof instance.onUnload === 'function') {
                    instance.onUnload(evt);
                }
            }

            return !isEventInstance;
        });
    },

    _onSelect: function(evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function(instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onSelect === 'function'
        ) {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function(evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function(instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onDeselect === 'function'
        ) {
            instance.onDeselect(evt);
        }
    },

    _onBlockSelect: function(evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function(instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockSelect === 'function'
        ) {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function(evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function(instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockDeselect === 'function'
        ) {
            instance.onBlockDeselect(evt);
        }
    },

    register: function(type, constructor) {
        this.constructors[type] = constructor;

        document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
            function(container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    }
});

theme.RecentlyViewed = (function() {

    /**
     * Initializes the recently viewed section. Only works on once per page.
     * @param {Node} container section container element
     */
    function RecentlyViewed(container) {

        // Check for container
        if (!container) {
            console.log('Error. Recently viewed section must be provided a container in order to work.');
            return false;
        }

        //
        // Get data- attribute information.
        //

        // Get how many products to show variable.
        const DEFAULT_LIMIT = 4;

        // Get the data-limit value or set to default limit (6).
        const limit = container.dataset.limit ? container.dataset.limit : DEFAULT_LIMIT;

        const grid = container.dataset.grid;

        // Get the data-carousel value or set to false (boolean)
        const carousel = container.dataset.carousel ? container.dataset.carousel : false;

        // If data-carousel attribute is set to a string "true", then convert to the "true" boolean value otherwise return "false" boolean
        const carouselEnabled = (carousel === 'true');

        const wrapperId = 'recently-viewed-slider';

        //
        // Helper functions
        //

        /**
         * Callback function to reveal the entire section
         * @param  {String} wrapperId wrapper element
         * @todo use container instead of wrapper?
         */
        const revealOuterWrapper = (wrapperId = 'recently-viewed') => {

            // Bail if not wrapper Id
            if (!wrapperId) {
                console.log('Error. must provide a wrapperId as an argument.');
                return false;
            }

            // Get the wrapper element
            let wrapper = document.getElementById(wrapperId);

            // Bail if no wrapper element was found
            if (!wrapper) {
                console.log('Error. No wrapper element was found.');
                return false;
            }

            // If the fadeIn helper method is not available then simply
            // change to display block. Otherwise use the fadeIn helper
            // method to display the section.
            if (typeof theme.Helpers.fadeIn === undefined) {
                wrapper.style.display = 'block';
            } else if (typeof theme.Helpers.fadeIn === 'function') {
                theme.Helpers.fadeIn(wrapper);
            }
        };


        /**
         * Initialize the Flickity carousel.
         * @todo pass in container instead of using querySelector
         */
        const initCarousel = (wrapperId) => {

            if (!wrapperId) {
                console.log('Error. Must provide a wrapper element to initialze the carousel on.');
                return false;
            }

            // Get the carousel element
            const carousel = document.getElementById(wrapperId);

            // Bail if it does not exists.
            if (!carousel) {
                console.log('Error. No carousel element for recently viewed products found!');
                return false;
            }

            // Get config object from data- attribute
            const flktyData = carousel.dataset.flickityConfig;

            // Convert to a JSON object
            const flktyOptions = JSON.parse(flktyData);

            // If there are more products to show than what the products per row or "grid" option then there is enough to wrapAround, show prevNext buttons.
            if (Shopify.RecordViewedProducts.getCount() > grid) {
                flktyOptions.wrapAround = false;
                flktyOptions.prevNextButtons = true;
                flktyOptions.draggable = true;
            };

            // Initiate Flickity
            new Flickity(carousel, flktyOptions);
        };

        /**
         * Functions to run when showRecentlyViewed is done
         * @param  {boolean} carousel  determine sif using in a carousel or not
         * @param  {node} container container element
         * @param  {string} wrapperId ID of the wrapper inside the container that displays the products
         * @return {[type]}           [description]
         * @todo add checks
         */
        const afterComplete = (carousel, container, wrapperId) => {

            revealOuterWrapper('recently-viewed-slider');

            // If carousel is enabled
            if (carousel === true) {

                // Initialize the carousel
                initCarousel(wrapperId, this.container);
            }

            // Re-initialize Quickview
            Shopify.theme.quickview.init();
        };

        const viewedProduct = new ViewedProducts({
            howManyToShow: limit,
            wrapperId: wrapperId,
            onComplete: afterComplete.bind(this, carouselEnabled, container, wrapperId)
        });
    };

    return RecentlyViewed;
})();

const ViewedProducts = (function() {

    let Constructor = function(params) {
        const publicAPIs = {};

        // default configs
        var config = {
            howManyToShow: 3,
            howManyToStoreInMemory: 30,
            wrapperId: "recently-viewed-slider",
            onComplete: null,
        };

        // array containing recently viewed products
        var productHandleQueue = [];

        // wrapper element that displays the products
        var wrapper = null;

        // variable to keep track of how many products have been shown
        var shown = 0;

        // Handle cookie related operations
        var cookie = {
            configuration: {
                expires: 90,
                path: "/",
                domain: window.location.hostname,
            },
            name: "shopify_recently_viewed",
            write: function(recentlyViewed) {
                Cookies.set(this.name, recentlyViewed.join(" "), this.configuration);
            },
            read: function() {
                var recentlyViewed = [];
                var cookieValue = Cookies.get(this.name);
                if (cookieValue !== undefined && cookieValue !== '') {
                    recentlyViewed = cookieValue.split(" ");
                }
                return recentlyViewed;
            },
            destroy: function() {
                Cookies.remove(this.name, null, this.configuration);
            },
            remove: function(productHandle) {
                var recentlyViewed = this.read();
                var position = recentlyViewed.indexOf(productHandle);
                if (position !== -1) {
                    recentlyViewed.splice(position, 1);
                    this.write(recentlyViewed);
                }
            },
        };

        // Reveal wrapper element and show recently viewed products and run call back if provided one.
        var finalize = function() {
            // Check if any products were shown.
            if (shown > 0) {

                // Remove hidden class if it exists
                if (wrapper.classList.contains('recently-viewed-products--hidden')) {
                    wrapper.classList.remove('recently-viewed-products--hidden');
                }

                // If we have a callback.
                if (config.onComplete) {
                    try {
                        config.onComplete();
                    } catch (error) {}
                }
                const event = new Event('productsLoaded');
                document.dispatchEvent(event);
            } else {
                console.log('No recently viewed products to show');
                return false;
            }
        };

        // Format the product listing template by converting it into a DOM node, determining it's CSS grid classes and then wrapping it with those classes
        var formatTemplate = (product) => {

            // Check if the product data was passed
            if (!product) {
                console.log('Error. Must provide a valid product in order to format it');
                return false;
            }

            //
            // Convert the product into a node.
            //

            // Parse the product HTML into a DOM node.
            var parser = new DOMParser();
            var doc = parser.parseFromString(product, 'text/html');

            // Get the template element.
            var template = doc.querySelector('[data-html="listing"]');

            // Check if we have a valid template element.
            if (!template) {
                console.log('Error. Could not find template elment.');
                return false;
            }

            //
            // Wrap the product in a div with grid classes.
            //

            // Create div element
            let productWrap = document.createElement('div');


            // Apply classes
            productWrap.classList.add('slider__item');

            // Append product in wrapper element
            productWrap.appendChild(template.content);
            console.log(productWrap)

            if (!productWrap.getElementsByClassName('catalog-card__title')[0].textContent.toLowerCase().includes('sample')) {
                // Return the final product template
                return productWrap;
            }

        };


        // Use fetch api to get product data and add it to the list
        var moveAlong = function() {

            if (productHandleQueue.length && shown < config.howManyToShow) {

                // Build fetch url
                let furl = `/products/${productHandleQueue[0]}?view=listing`;

                // Fetch the product data
                fetch(furl)
                    .then((response) => {
                        // Convert data to text
                        return response.text();
                    })
                    .then((response) => {

                        // Get the formated product node with the data

                        let product = formatTemplate(response);

                        // Append the product to the wrapper element
                        wrapper.appendChild(product);

                        // Remove first element from the array
                        productHandleQueue.shift();

                        // Increment shown
                        shown++;

                        // Recursively call function
                        moveAlong();
                    })
                    .catch((error) => {
                        // Log error
                        console.log(error.message);
                        // Remove first product from the array from the cookie
                        cookie.remove(productHandleQueue[0]);
                        productHandleQueue.shift();
                        moveAlong();
                    });
            } else {
                finalize();
            }
        };

        publicAPIs.showRecentlyViewed = function(params) {
            var params = params || {};

            // Update defaults.
            config = Object.assign(config, params);

            // Reset
            shown = 0;
            productHandleQueue = [];
            wrapper = null;
            template = null;

            // Read cookie.
            productHandleQueue = cookie.read();

            // Get the wrapper element
            wrapper = document.getElementById(config.wrapperId);

            // If we have any to show.
            if (config.howManyToShow && wrapper) {
                // Getting each product with an Ajax call and rendering it on the page.
                moveAlong();
            }
        };
        publicAPIs.getConfig = function() {
            return config;
        };
        publicAPIs.clearList = function() {
            cookie.destroy();
        };
        publicAPIs.getCount = function() {
            let productHandleQueue = cookie.read();
            return productHandleQueue.length;
        };

        publicAPIs.showRecentlyViewed(params);

        return publicAPIs;
    };

    return Constructor;
})();

Shopify.RecordViewedProducts = (function() {

    // default configs
    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 30,
        wrapperId: "recently-viewed-slider",
        onComplete: null,
    };

    // array containing recently viewed products
    var productHandleQueue = [];

    // wrapper element that displays the products
    var wrapper = null;

    // variable to keep track of how many products have been shown
    var shown = 0;

    // Handle cookie related operations
    var cookie = {
        configuration: {
            expires: 90,
            path: "/",
            domain: window.location.hostname,
        },
        name: "shopify_recently_viewed",
        write: function(recentlyViewed) {
            Cookies.set(this.name, recentlyViewed.join(" "), this.configuration);
        },
        read: function() {
            var recentlyViewed = [];
            var cookieValue = Cookies.get(this.name);
            if (cookieValue !== undefined && cookieValue !== '') {
                recentlyViewed = cookieValue.split(" ");
            }
            return recentlyViewed;
        },
        destroy: function() {
            Cookies.remove(this.name, null, this.configuration);
        },
        remove: function(productHandle) {
            var recentlyViewed = this.read();
            var position = recentlyViewed.indexOf(productHandle);
            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        },
    };

    return {
        getConfig: function() {
            return config;
        },
        clearList: function() {
            cookie.destroy();
        },
        getCount: function() {
            let productHandleQueue = cookie.read();
            return productHandleQueue.length;
        },
        recordRecentlyViewed: function(params) {

            var params = params || {};

            // Update defaults.
            config = Object.assign(config, params);

            // Read cookie.
            var recentlyViewed = cookie.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf("/products/") !== -1) {

                // What is the product handle on this page.
                var urlPathname = new URL(window.location).pathname;
                var urlArray = decodeURIComponent(urlPathname).split('/');
                var productHandle = urlArray[urlArray.indexOf('products') + 1];
                if (!productHandle) {
                    console.log('Error, no product handle found.');
                    return false;
                }

                // In what position is that product in memory.
                var position = recentlyViewed.indexOf(productHandle);


                // If not in memory. (product handle was not found in the recentlyv)
                if (position === -1) {

                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);

                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(
                        0,
                        config.howManyToStoreInMemory
                    );
                } else {
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                cookie.write(recentlyViewed);
            }
        },
    };
})();


document.addEventListener('DOMContentLoaded', (event) => {
    if (document.body.classList.contains('template-product')) {
        Shopify.RecordViewedProducts.recordRecentlyViewed();
    }

    var sections = new theme.Sections();
    sections.register('recently-viewed', theme.RecentlyViewed);
})
